import { NodeEditor } from 'rete';

import ReteInput, {
  ReteInputParams,
} from 'pipelines/services/rete/controls/input';

import {
  TrackableItemPropertyInput,
  TrackableItemPropertyInputProps,
} from 'pipelines/components/TrackableProperties';

type TrackableItemsInputParams = Omit<ReteInputParams, 'type'> & {
  trackableListField?: string;
};

export default class ReteTrackableItemsInput extends ReteInput<TrackableItemPropertyInputProps> {
  constructor(
    editor: NodeEditor,
    key: string,
    params: TrackableItemsInputParams = {}
  ) {
    const { trackableListField, ...rest } = params;
    super(editor, key, { ...rest, type: 'string', inputType: 'select' });
    this.props.trackableListField = trackableListField;
  }

  get component() {
    return TrackableItemPropertyInput;
  }
}
